export enum ViewState
{
    Init = 0,
    Choosepayment = 1,
    Dopayment = 2,
    ShowCoupon = 3,
    Ready = 4,
    Open = 5,
    CheckSuccess = 6,
    ShowAmazon = 7,
    ShowGooglepayOverPaypal = 8
}